import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function getReturnPath() {
  const saved = localStorage.getItem('stripe_return_path');
  localStorage.removeItem('stripe_return_path');
  return saved || '/map';
}

const CreditCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const returnPath = getReturnPath();
    const timer = setTimeout(() => navigate(returnPath), 1500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#111', color: '#f5f5f5',
      fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        background: '#1f1f1f', borderRadius: 12, padding: 32,
        textAlign: 'center', maxWidth: 400,
      }}>
        <h2 style={{ margin: '0 0 12px' }}>Purchase Cancelled</h2>
        <p style={{ color: '#cfcfcf', fontSize: 16 }}>No charges were made.</p>
        <p style={{ color: '#9c9c9c', fontSize: 13 }}>Redirecting back...</p>
      </div>
    </div>
  );
};

export default CreditCancel;
